export let OnCloseInlineComposeActionName = 'onCloseInlineCompose';
export let UpdateInternetMessageIdName = 'UpdateInternetMessageId';
export let CloseComposeActionName = 'closeCompose';
export let openComposeActionName = 'openCompose';
